import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import PrimaryButton from '../../../../../../common/StyledComponents/PrimaryButton';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import {theme} from '../../../../../../Theme';
import SecondaryButton from '../../../../../../common/StyledComponents/SecondaryButton';
import BidmiiRadio from '../../../../../../common/StyledComponents/BidmiiRadio';
import StandardDialog from '../../../../../../common/StyledComponents/StandardDialog';

export default function CancelProjectDialog(props: $TSFixMe) {
  const [value, setValue] = useState(null);
  const [reason, setReason] = useState(null);

  const handleChange = (event: $TSFixMe) => {
    setValue(event.target.value);
    setReason(event.target.value);
  };

  return (
    <StandardDialog
      open={props.open}
      hideCloseButton
      secondaryAction={
        <SecondaryButton onClick={props.handleClose}>CANCEL</SecondaryButton>
      }
      primaryAction={
        <PrimaryButton
          color={theme.palette.red.main}
          onClick={() => props.onSubmit(reason)}
          disabled={!reason || reason === 'other'}>
          DELETE PROJECT
        </PrimaryButton>
      }>
      <div>
        <Typography variant="body1" fontSize={24} lineHeight={1.3} gutterBottom>
          Are you sure you want to delete your project?
        </Typography>
        <Typography
          variant={'subtitle1'}
          fontSize={15}
          style={{color: theme.palette.gray.dark}}>
          This step can not be undone
        </Typography>

        <Box pt={2}>
          <Box
            style={{
              border: `1px solid ${theme.palette.gray.border}`,
              padding: 10,
            }}>
            <FormControl variant="standard" component="fieldset">
              <FormLabel component="legend">
                Please let us know why you’ve decided to delete this project.
              </FormLabel>
              <RadioGroup
                aria-label="reason"
                name="reason"
                value={value}
                onChange={handleChange}>
                <BidmiiRadio
                  state={value}
                  value="Due to the cost"
                  label="Due to the cost"
                />
                <BidmiiRadio
                  state={value}
                  value="Not enough bids"
                  label="Not enough bids"
                />
                <BidmiiRadio state={value} value="other" label="Other" />
              </RadioGroup>
            </FormControl>
            {value === 'other' && (
              <div style={{width: '100%'}}>
                <TextField
                  variant="standard"
                  id="other"
                  label="Reason"
                  fullWidth={true}
                  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                  onChange={(event) => setReason(event.target.value)}
                />
              </div>
            )}
            {/* COMMENTED OUT FOR PERCH NEGOTIATIONS */}
            {/*value === 'Due to the cost' && (
            <InfoBanner
              title={'Financing options available'}
              buttonText={'Learn More'}
              onClick={() => history.push('/resources/what_is_perch')}
            />
          )*/}
          </Box>
        </Box>
      </div>
    </StandardDialog>
  );
}
